export default __webpack_public_path__ + "static/media/15.775dbd33.svg";